"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Go to the first page": "Zur ersten Seite",
  "Go to the last page": "Zur letzten Seite",
  "Pagination, showing {from} through {to} of {total} entities": ["Seitenanzahl, angezeigt werden ", ["from"], " bis ", ["to"], " von ", ["total"], " Elementen"],
  "Show next {entitiesPerPage} entities": ["Die nächsten ", ["entitiesPerPage"], " Elemente anzeigen"],
  "Show previous {entitiesPerPage} entities": ["Die letzten ", ["entitiesPerPage"], " Elemente anzeigen"],
  "{from} through {to} of {total}": [["from"], " bis ", ["to"], " von ", ["total"]],
  "{from}-{to} of {total}": [["from"], "–", ["to"], " von ", ["total"]]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map